import React, { useEffect, useState } from 'react';
import { Text } from 'react-native';
import { FirebaseRemoteConfig } from '../../utils/FirebaseRemoteConfig';
import { Logger } from '../../utils/Logger';

const templateString = (inputString: string, vars: any) => new Function('return `' + inputString + '`;').call(vars);

export const FirebaseConfigText = ({
  remoteConfigKey,
  style,
  stringTemplateValues = {},
  transformFunction = (input: string) => input,
}) => {
  const [text, setText] = useState('');
  useEffect(() => {
    async function getRemoteText() {
      const textFromRemoteConfig = await FirebaseRemoteConfig.getRemoteConfigValue(
        remoteConfigKey,
      );
      const formattedText = templateString(textFromRemoteConfig, stringTemplateValues);
      const transformed = transformFunction(formattedText);
      setText(transformed);
    }
    getRemoteText()
      .catch((e) => Logger.notify(e));
  }, []);
  if (text) {
    return <Text style={style}>{text}</Text>;
  }
  return <></>;
};
